import React from 'react';

import {
  QueueTabBar,
  routeDirectory
} from 'modules';

import { useNavigate } from 'react-router-dom';
import * as dataService from './dataService';
import * as shared from '../shared';



const TabBar = QueueTabBar.genTabBarComponent({ tabs: shared.tabs });



export interface IProps {
  storeId?: string;
}

export const FC: React.FC<IProps> = props => {
  const params = shared.useReturnAuthorizationActivityParams();
  const queryTuple = dataService.useQuery(props.storeId);
  const navigate = useNavigate();
  const loading = queryTuple.loading;

  return (
    <TabBar
      loading={loading}
      value={params.tabId}
      tabId2ItemCount={{
        awaitingAcceptance: queryTuple.data.numPendingAcceptance,
        awaitingApproval: queryTuple.data.numPendingApproval,
        awaitingReceipt: queryTuple.data.numPendingReceipt,
        awaitingShippingLabel: queryTuple.data.numPendingShippingLabel,
        refund: queryTuple.data.numPendingRefund
      }}
      onChange={tabId => {
        navigate(routeDirectory.admin.returnAuthorizations.list.path(tabId, props.storeId), { replace: true });
      }} />
  );
};
